<div class="content-wrapper-inner relative">
  <div class="page-content">
    <app-users-search (onSubmit)="onSubmitSearchForm($event)"></app-users-search>
    <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
      <app-users-table (actions)="userAction($event)" (changeBatch)="selectedRows.set($event)"></app-users-table>

      <!-- The table on batch select has an action menu shown … -->
      <div class="table-action-info-bar" *ngIf="selectedRows().length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{ selectedRows().length }} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onBatchEnabled(true)">
            <span class="icon">
              <span class="icon-positive"></span>
            </span>
            <span class="text">Enable</span>
          </div>
          <div class="text-icon-holder" (click)="onBatchEnabled(false)">
            <span class="icon">
              <span class="icon-negative"></span>
            </span>
            <span class="text">Disable</span>
          </div>
          <div class="text-icon-holder" (click)="onBatchDelete()">
            <span class="icon">
              <span class="far fa-trash-alt"></span>
            </span>
            <span class="text">Delete</span>
          </div>
          <button class="btn ghost-btn btn-action text-icon-holder" [disabled]="batchAgreementCount() === 0" (click)="onBatchEnableCustomAgreement()">
            <span class="icon">
              <span class="icon-done"></span>
            </span>
            <span class="text">Set “Yes, other (custom accepted)”</span>
          </button>
          <button
            class="btn ghost-btn btn-action text-icon-holder"
            [disabled]="batchAgreementCount() === 0"
            (click)="onBatchEnableClicktermAgreement()">
            <span class="icon">
              <span class="icon-positive"></span>
            </span>
            <span class="text">Enable ClickTerm Agreements</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #batchAgreementModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ batchAgreementModalTitle() }}</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <label class="form-label">{{ batchAgreementModalText() }}</label>
    <div class="bulk-user-email-list">
      <div class="bulk-user-email-row" *ngFor="let email of batchAgreementUserEmails()">
        {{ email }}
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-dark px-20" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-20" (click)="dialogRef.close(true)" [disabled]="batchAgreementCount() === 0">Confirm</button>
    </div>
  </div>
</ng-template>
